export default __webpack_public_path__ + "static/media/leftFog.d7dbc887.svg";